import { useEffect, useRef, useState } from 'react';
import { apiRequest } from '../../api/http';
import { useAuth, type Session } from '../../auth/AuthContext';
import { navigate, Link } from '../../app/router';
import { Spinner } from '../../shared/components';

export function WebAuthHandoffPage() {
  const auth = useAuth();
  const started = useRef(false);
  const [error, setError] = useState('');
  useEffect(() => {
    // Complete restoration first so it cannot overwrite the handed-off session.
    if (started.current || auth.restoring) return;
    started.current = true;
    const token = new URLSearchParams(window.location.search).get('token') || '';
    window.history.replaceState({}, '', '/auth/handoff');
    if (!token) { setError('ลิงก์เข้าสู่ระบบไม่ถูกต้อง'); return; }
    void apiRequest<Session>('/auth/app-handoff/consume', { method: 'POST', body: { token } })
      .then(session => { auth.establishSession(session); navigate('/for-merchant/manage', true); })
      .catch(() => setError('ลิงก์เข้าสู่ระบบหมดอายุหรือถูกใช้แล้ว กรุณาเข้าสู่ระบบอีกครั้ง'));
  }, [auth.restoring]);
  return <main className="auth-shell"><section className="panel">{error ? <><p role="alert">{error}</p><Link to="/login?next=/for-merchant/manage">เข้าสู่ระบบ</Link></> : <Spinner label="กำลังเข้าสู่ระบบให้อัตโนมัติ..." />}</section></main>;
}
